// Generated by ReScript, PLEASE EDIT WITH CARE


function importCss(param) {
  return (require(`RaiseTicketAssets/styles/_all.scss`));
}

export {
  importCss ,
  
}
/* No side effect */
